import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React, { useEffect, useState } from 'react';
import {
  useGetSoakingActionButtons,
  useFetchSoakings,
  useSaveNUpdateSoakingsHandler,
} from './hooks';
import { soakingColumns } from './utils';
import { ProtectantAgents } from '.';
import { useSoakings } from 'redux/hooks/synchrotron';
import { ProtectantAgentType } from './constants';
import { ModalDetails } from 'business/models/CustomModels';
import { useCurrentWell } from 'redux/hooks/crystal';

const Soaking = () => {
  const soakingList = useSoakings();
  const [selectedRows, setSelectedRows] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [soakings, setSoakings] = useState(soakingList);
  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => {},
    body: '',
    heading: 'Warning',
    isOkOnly: false,
    okButtonText: 'Proceed',
    noButtonText: 'Cancel',
    showButtons: true,
  });

  useFetchSoakings();
  const saveUpdateSoakingsHandler = useSaveNUpdateSoakingsHandler();
  const actionButtons: RMCustomButtonProps[] = useGetSoakingActionButtons(
    soakings,
    setSoakings,
    selectedRows,
    setSelectedRows,
    editId,
    setEditId,
    setModalDetails,
  );
  const currentWell = useCurrentWell();
  useEffect(() => {
    setSoakings(soakingList);
  }, [soakingList]);

  useEffect(() => {
    setEditId(null);
  }, [currentWell?.wellId]);

  return (
    <ProtectantAgents
      protectantAgentType={ProtectantAgentType.Soaking}
      buttons={actionButtons}
      tableProps={{
        columns: [...soakingColumns],
        data: soakings,
        selectedIds: selectedRows,
      }}
      setSelectedRows={setSelectedRows}
      editedData={editedData}
      setEditedData={setEditedData}
      setProtectantData={setSoakings}
      editId={editId}
      setEditId={setEditId}
      saveUpdateProtectantHandler={saveUpdateSoakingsHandler}
      modalDetails={modalDetails}
      setModalDetails={setModalDetails}
    />
  );
};

export default Soaking;
